import styled from 'styled-components';

export const Container = styled.button`
  width: 75px;
  height: 75px;
  background: #166649;
  border-radius: 50%;
  overflow: hidden;
  position: fixed;
  bottom: 2.5rem;
  right: 3rem;
  padding: 0.9rem;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  border: none;
  outline: none;
  z-index: 9;

  img {
    width: 45px;
    display: flex;
    justify-content: center;
    align-items: center;
  }
`;
